<div class="footer">
<div class="content-container">
<div class="borderhr"></div>
<div class="mobilehidden">
    <div class="pure-u-md-5-24 pure-u-lg-6-24">
        <a href="https://www.csl.com/we-are-csl/our-businesses-and-products/csl-behring" target="_blank"><img src="/assets/img/CSLBehring.svg" alt="CSL Behring logo" title="CSL Behring logo"></a>
    </div>

    <div class="pure-u-md-19-24 pure-u-lg-18-24 anchorlinks">
       <a href="https://www.csl.com/privacy-policy" target="_blank">Privacy Policy</a>|       
       <a href="https://www.csl.com/terms-of-use" target="_blank">Terms of Use</a>|       
       <a href="https://www.csl.com/we-are-csl" target="_blank">About CSL Behring</a>|       
       <a href="/cookie-policy">Cookie Policy</a>
    </div>
    <div class="footerinfo">
        <div>
            <b>©2024 CSL Behring LLC.</b>
        </div>
        <div>1020 First Avenue, PO Box 61501, King of Prussia, PA 19406-0901 USA</div>
        <div class="pure-g">
            <div class="pure-u-12-24"><b>www.CSLBehring.com</b>     USA-GDM-0078-APR24</div>
            <div class="pure-u-12-24 divinfo">The information presented on this site is intended for US residents only.</div>
        </div>
    </div>
</div>
<div class="desktophidden">
  <div class=" anchorlinks">
    <a href="https://www.csl.com/privacy-policy" target="_blank">Privacy Policy</a>
    <a href="https://www.csl.com/terms-of-use" target="_blank">Terms of Use</a>
    <a href="https://www.csl.com/we-are-csl" target="_blank">About CSL Behring</a>
    <a href="/cookie-policy">Cookie Policy</a>
  </div>
  <div class="pure-u-24-24">
    <a href="https://www.csl.com/we-are-csl/our-businesses-and-products/csl-behring" target="_blank"><img src="/assets/img/CSLBehring.svg" alt="CSL Behring logo" title="CSL Behring logo"></a>
  </div>
  <div class="footerinfo">
    <div>
      <b>©2024 CSL Behring LLC.</b>
    </div>
    <div>1020 First Avenue, PO Box 61501 <br>
      King of Prussia, PA 19406-0901 USA</div>
    <div class="pure-g">
      <div class="pure-u-24-24"><b>www.CSLBehring.com</b>     USA-GDM-0078-APR24</div>
      </div><br>
    <div class="pure-g">
      <div class="pure-u-24-24 divinfo">The information presented on this site is <br>intended for US residents only.</div>
    </div>
  </div>
</div>
</div>
</div>
